export const TriggerDarkMode = "TriggerDarkMode";
export const TriggerLightMode = "TriggerLightMode";
export const CreateDarkModeKey = "CreateDarkModeKey";
